import { useSelector } from 'react-redux';
import { toFixed2 } from '../../components/DexTrades/formatters';
import usePriceChange from '../../components/Info/usePriceChange';
import { formatUSD } from '../../components/Modal/TickersModal/helper';
import { getPriceChangeArgs } from '../../components/Watchlist/DailyPriceChange';
import useTickerLivePrice from '../../components/Watchlist/useTickerLivePrice';
import useTicker from '../../hooks/useTicker';
import { IStore } from '../../reducers';
import { ICurrentState } from '../../reducers/current';
import PairIcons from '../PairIcons';

import './styles.scss';

interface ITickerCardProps {
  ticker: ICurrentState;
}
/**
 * A mobile view card which displays info about pair
 * @param props
 * @returns
 */
const TickerCard = ({ ticker }: ITickerCardProps) => {
  const { name, base_address, quote_address, chain, base_slug, quote_slug } =
    useTicker(ticker);
  const { price } = useTickerLivePrice(ticker);

  const args = getPriceChangeArgs(ticker);

  const { priceChange, priceChangePercent } = usePriceChange(
    Number(price.slice(1)),
    ticker.flipped,
    args.chain,
    args.address
  );

  const { volume, liquidity } = ticker;
  const subName = priceChangePercent > 0 ? 'green' : 'red';

  return (
    <div className='ticker__card'>
      <div className='ticker__card__hd'>
        <div className='ticker__card__hd__left'>
          <div className='ticker__card__hd__left__group'>
            <PairIcons
              chain={chain}
              pair={name}
              base_address={base_address}
              quote_address={quote_address}
              base_slug={base_slug}
              quote_slug={quote_slug}
            />
          </div>
          <span>{name}</span>
        </div>
        <div className='ticker__card__hd__right'>
          <span>{price}</span>
          {priceChangePercent !== 0 && (
            <div
              className={`ticker__card__hd__right__sub ticker__card__hd__right__sub--${subName}`}
            >
              ({toFixed2(priceChangePercent)}%) ${toFixed2(priceChange)}
            </div>
          )}
        </div>
      </div>
      <div className='ticker__card__info'>
        <div className='ticker__card__info__side'>
          <span>Daily volume:</span>
          <div className='ticker__card__info__side__content'>
            {formatUSD(volume)}
          </div>
        </div>
        <div className='ticker__card__info__separator' />
        <div className='ticker__card__info__side'>
          <span>Pool liquidity</span>
          <div className='ticker__card__info__side__content'>
            {formatUSD(liquidity)}
          </div>
        </div>
      </div>
    </div>
  );
};

const CurrentTickerCard = () => {
  const ticker = useSelector((state: IStore) => state.current);
  return <TickerCard ticker={ticker} />;
};

export { CurrentTickerCard, TickerCard };
